<template>
  <div class="my_container">
    <div class="personal_center_box">
      <div class="personal_center_top">
        <p class="personal_center_bg_img">
          <img src="../../assets/img/personalBanner.png" alt="头像">
        </p>
        <div class="personal_center_info">
          <p class="personal_center_info_pic">
            <img :src="detail.portrait" alt="">
          </p>
          <div class="personal_center_user">
            <p class="personal_center_user_name">
              {{detail.user_name}}
              <el-popover
                v-if="detail.is_enterprise === 1"
                placement="top-start"
                trigger="hover"
                content="已通过平台实名认证">
                <i class="my_icon_list shiming" slot="reference"></i>
              </el-popover>
              <el-popover
                v-if="detail.is_authentication === 1"
                placement="top-start"
                trigger="hover"
                content="已通过平台播主认证">
                <i class="my_icon_list bozhu" slot="reference"></i>
              </el-popover>
              <el-popover
                v-if="detail.is_lawyer === 1"
                placement="top-start"
                trigger="hover"
                content="已通过平台律师认证">
                <i class="my_icon_list lvshi" slot="reference"></i>
              </el-popover>
              <el-popover
                v-if="detail.is_personal === 1"
                placement="top-start"
                trigger="hover"
                content="已通过平台企业认证">
                <i class="my_icon_list qiye" slot="reference"></i>
              </el-popover>
            </p>
            <div v-if="detail.is_lawyer === 1 || detail.is_personal === 1">
              <div v-show="detail.is_personal === 1" class="personal_center_user_text">
                <span>认证企业：</span>
                {{detail.enterprise_name}}
              </div>
              <div v-show="detail.is_lawyer === 1" class="personal_center_user_text">
                <span>执业律所：</span>
                {{detail.law_firm}}
              </div>
            </div>
            <div v-else>
              <div class="personal_center_user_text">
                <span>职业：</span>
                <p v-if="detail.industry !== null">{{detail.industry}}</p>
                <p v-else>未填写</p>
              </div>
            </div>
            <div v-show="personalSlid" class="personal_center_user_text">
              <span>所在地：</span>
              <p v-if="detail.area !== ''">{{detail.area}}</p>
              <p v-else>未填写</p>
            </div>
            <div v-show="personalSlid && detail.professional_experience.length > 0" class="personal_center_user_text">
              <span>职业经历：</span>
              <p v-for="item in detail.professional_experience" :key = "item.id">
                {{item.company}} - {{item.position}}
              </p>
            </div>
            <div v-show="personalSlid && detail.educational_experience.length > 0" class="personal_center_user_text">
              <span>教育经历：</span>
              <p v-for="item in detail.educational_experience" :key = "item.id">
                {{item.school}} - {{item.major}} - {{item.education}}
              </p>
            </div>
            <div v-show="personalSlid" class="personal_center_user_text">
              <span>简介：</span>
              <p v-if="detail.content !== null">{{detail.content}}</p>
              <p v-else>未填写</p>
            </div>
            <div class="personal_center_user_btn">
              <button v-show="!personalSlid" class="my_follow_btn" @click="personalSlid = true">展开更多详情</button>
              <button v-show="personalSlid" class="my_follow_btn" @click="personalSlid = false">收起更多详情</button>
            </div>
          </div>
          <div class="personal_center_follow_btn">
            <el-button v-if="detail.is_follow === 0" class="personal_center_add_follow" @click="addFollow(userId)"> + 关注 </el-button>
            <el-button v-if="detail.is_follow === 1" class="personal_center_center_follow" @click="cancelFollow(userId)"> 已关注 </el-button>
          </div>
        </div>
      </div>
      <div class="personal_center_bottom">
        <div class="glag_left">
          <div class="title_top_hr">
            <p>
              <i></i>
              <span class="comment_btn personal_cneter_title_btn" :class="navTop === '全部' ? 'act' : ''" @click="sortBtn('全部')">全部</span>
              <span class="comment_btn personal_cneter_title_btn" :class="navTop === '直播' ? 'act' : ''" @click="sortBtn('直播')">直播</span>
              <span class="comment_btn personal_cneter_title_btn" :class="navTop === '文章' ? 'act' : ''" @click="sortBtn('文章')">文章</span>
              <span class="comment_btn personal_cneter_title_btn" :class="navTop === '视频' ? 'act' : ''" @click="sortBtn('视频')">视频</span>
              <el-divider></el-divider>
            </p>
          </div>
          <div
          v-loading="listLoading"
          element-loading-text="列表加载中"
          element-loading-spinner="el-icon-loading">
            <div v-if="applyList.length === 0" class="my_none">
              <img class="my_none_img" src="../../assets/img/user/myDynamicNone.png" alt="用户发表内容为空">
              <p class="my_none_user_text">
                <span v-if="navTop === '全部'">该用户暂且未发布任何文章或视频！</span>
                <span v-if="navTop === '直播'">该用户暂且未进行直播！</span>
                <span v-if="navTop === '视频'">该用户暂且未发布任何视频！</span>
                <span v-if="navTop === '文章'">该用户暂且未发布任何文章！</span>
              </p>
            </div>
            <div v-else class="personal_center_list">
              <div class="personal_center_item" v-for="(item, index) in applyList" :key="item.id">
                <div class="personal_center_item_top" :class="item.img === '' ? 'personal_center_item_left' : ''">
                  <div v-if="item.img !== ''"  class="personal_center_left">
                    <img :src="item.img" alt="">
                    <i v-if="item.type === 1" class="my_icon_list player_icon"></i>
                  </div>
                  <div class="personal_center_right">
                    <div class="personal_center_title">
                      <a @click="jump(item.list_id, item.nav_id, item.is_doing, index)">
                        {{item.title}}
                      </a>
                    </div>
                    <div class="personal_center_content">
                      {{item.title}}
                    </div>
                  </div>
                </div>
                <div class="personal_center_item_bottom">
                  <div class="personal_center_time lf">
                    {{item.add_time}}
                  </div>
                  <div class="personal_center_other rt">
                    <el-breadcrumb separator="|">
                      <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.like}}</span></a></el-breadcrumb-item>
                      <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.favorites}}</span></a></el-breadcrumb-item>
                      <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon fenxiang"></i><span class="my_icon_text">{{item.share}}</span></a></el-breadcrumb-item>
                      <el-breadcrumb-item></el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="glag_right">
          <div class="personal_center_right">
            <div class="personal_center_right_top">
              创作{{detail.creation}}天，发布量{{detail.total_count}}
            </div>
            <div class="personal_center_right_center">
              <p class="personal_center_right_apply">
                <span>直播</span>
                {{detail.live_count}}
              </p>
              <p class="personal_center_right_apply">
                <span>文章</span>
                {{detail.article_count}}
              </p>
              <p class="personal_center_right_apply">
                <span>视频</span>
                {{detail.videos_count}}
              </p>
            </div>
            <div class="personal_center_right_bottom">
              <p class="lf">
                <i>{{detail.fans_count}}</i><br/>
                粉丝
              </p>
              <el-divider class="lf" direction="vertical"></el-divider>
              <p class="lf">
                <i>{{detail.like_Count}}</i><br/>
                获赞
              </p>
              <el-divider class="lf" direction="vertical"></el-divider>
              <p class="lf">
                <i>{{detail.collection_count}}</i><br/>
                收藏
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      personalSlid: false, // 个人信息展开收起按钮
      listLoading: true, // 加载动画
      navTop: '全部', // 导航切换
      userId: '', // 用户id
      detail: {},
      slidIndex: '',
      applyList: [], // 发布文章列表
      applyListPage: {
        limit: 10,
        page: 1,
        user_id: '',
        type: 0 // 0全部 1直播 2视频 3文章
      }
    }
  },
  created () {
    this.userId = this.$route.query.id
    this.getMyInfo()
    this.getMyApply()
  },
  methods: {
    // 头部切换
    sortBtn (name) {
      this.navTop = name
      switch (name) {
        case '全部':
          this.applyListPage.type = 0
          break
        case '直播':
          this.applyListPage.type = 1
          break
        case '文章':
          this.applyListPage.type = 3
          break
        case '视频':
          this.applyListPage.type = 2
          break
      }
      this.getMyApply()
    },
    // 获取信息与其它
    getMyInfo () {
      const vueThat = this
      vueThat.myApi.getUserDetails({ user_id: vueThat.userId }).then((res) => {
        if (res.data.code === 200) {
          vueThat.detail = res.data.data
        }
      })
    },
    // 获取发布列表
    getMyApply () {
      const vueThat = this
      vueThat.applyListPage.user_id = vueThat.userId
      vueThat.myApi.getBloggerDetails(vueThat.applyListPage).then((res) => {
        this.listLoading = false
        if (res.data.code === 200) {
          vueThat.applyList = res.data.data
        }
      })
    },
    // 关注
    addFollow (id) {
      const vueThat = this
      vueThat.myApi.addFollow({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$alert('关注成功', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              vueThat.detail.is_follow = 1
            }
          })
        }
      })
    },
    // 取消关注
    cancelFollow (id) {
      const vueThat = this
      vueThat.$confirm('是否取消关注?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id)
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.detail.is_follow = 0
          }
        })
      }).catch(() => {})
    },
    // 页面跳转
    jump (id, navId, isDoing, index) {
      if (navId === 5 || navId === 10) {
        if (this.applyList[index].video_status === 0) {
          this.$alert('直播已结束，回放正在生成中，请稍后...', '温馨提示', {
            type: 'success',
            confirmButtonText: '确认',
            showClose: false
          })
        } else if (this.applyList[index].video_status === 1) {
          this.mycommon.detailJump(this, id, navId, isDoing)
        } else {
          this.$alert('直播已结束!', '温馨提示', {
            type: 'success',
            confirmButtonText: '确认',
            showClose: false
          })
        }
      } else {
        this.mycommon.detailJump(this, id, navId, isDoing)
      }
    }
  }
}
</script>

<style>
</style>
